import Api from "./Api";
import ClientApi from "./ClientApi";

export default {
    /**
     * @param {string} subdomain
     * @param {{server_name: string, server_api: string}} server
     * @param {Object} [config] Extra axios request config. CL-18307 passes a
     *   `cancelToken` here so a probe the user has already typed past can be
     *   taken off the wire instead of running to completion for an answer that
     *   is guaranteed to be discarded.
     */
    checkEntitySubdomain(subdomain , server, config) {
        return ClientApi(server).get(`check_subdomain_for_passport?subdomain=${encodeURIComponent(subdomain)}`, config);
    },
    createEntity(params) {
        let server = params.server;
        delete params.server;
        return ClientApi(server).post(`create_entity_for_passport` , params);
    },
    attachUserToEntity(entityId){
        const userId = JSON.parse(localStorage.getItem("user")).data.user.id;
        return Api().post(`/add-entity-user` , {
            'entity_id' : entityId,
            'user_id': userId
        });
    }

};
